import React from "react";
import CreateScreen from "../../../../../Components/ReverseAuction/CreateScreen/CreateScreen";

const ReverseAuctionGenerator = ({ rfq }) => {
  return (
    <div>
      <CreateScreen rfq={rfq} />
    </div>
  );
};

export default ReverseAuctionGenerator;
